import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRICING_OUTCOME } from "../lib/content";

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-[#F3EFE6] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="kicker">Pricing</p>
            <h2 className="h-section text-[clamp(2rem,4.2vw,3.4rem)] mt-5">
              You only pay when it pays for itself.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-serif-body text-[#4A4A4A] text-[1.05rem] leading-relaxed">
              Three outcome-based tracks. Flat monthly or a share of the
              revenue we save you — whichever feels honest. Auto-refund if we
              miss our promise. You don't ask; it just happens.
            </p>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {PRICING_OUTCOME.map((o, i) => (
            <motion.div
              key={o.name}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="p-8 bg-[#0B3D5C] text-white flex flex-col"
              data-testid={`pricing-outcome-${o.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <p className="kicker text-[#E07B3A]">Track {i + 1}</p>
              <h3 className="h-card text-[1.4rem] mt-3 text-white">{o.name}</h3>

              <div className="mt-5 flex items-baseline gap-3">
                <span className="font-sans-tight font-extrabold text-[2.4rem] text-white tracking-tight leading-none">
                  {o.price}
                </span>
                <span className="font-sans-tight text-[13px] text-white/55">/mo flat</span>
              </div>
              <p className="font-mono-spec text-[12px] text-[#E07B3A] mt-3 uppercase tracking-widest">
                {o.or}
              </p>
              <p className="font-serif-body text-[15px] text-white/85 mt-4 leading-relaxed flex-1">
                {o.desc}
              </p>

              <div className="mt-7 pt-5 border-t border-white/15">
                <p className="font-mono-spec text-[11px] uppercase tracking-widest text-white/55">
                  Auto-refund
                </p>
                <p className="font-serif-body text-[14px] text-white/85 mt-1">
                  If we miss the promise, you get the month back. Automatically.
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 border-t border-[#E5E0D8] pt-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="font-serif-body text-[#1A1A1A] text-[15px] max-w-xl">
            Subscriptions come later — once we've proven the outcome with
            you. Founding customers lock in 50% off whichever track they pick.
          </p>
          <a
            href="#founding"
            className="btn btn-primary"
            data-testid="pricing-cta"
          >
            Lock in founding pricing <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
